import { useCallback, useEffect, useState } from 'react';

// tela cheia sem travar orientação: a Arena joga em pé e de lado
export const useGbScreen = () => {
  const [cheia, setCheia] = useState(false);

  useEffect(() => {
    const sync = () => setCheia(!!document.fullscreenElement);
    sync();
    document.addEventListener('fullscreenchange', sync);
    return () => document.removeEventListener('fullscreenchange', sync);
  }, []);

  const entrar = useCallback(async () => {
    const el = document.documentElement;
    try {
      if (!document.fullscreenElement) {
        await (el.requestFullscreen?.({ navigationUI: 'hide' }) || el.webkitRequestFullscreen?.());
      }
    } catch (e) { /* navegador pode negar */ }
  }, []);

  const sair = useCallback(async () => {
    try { await (document.exitFullscreen?.() || document.webkitExitFullscreen?.()); } catch (e) { /* noop */ }
  }, []);

  return { cheia, entrar, sair };
};
